import { EditStep, type EditStore } from './types';

export const initialState: EditStore = {
	orderRotationLoading: false,
	step: EditStep.List,
	rotationDetailVariant: undefined,
	initialRotation: undefined,
	recipientUpdate: undefined,
};
